import { useLayoutEffect, useRef } from 'react'
import { useNavigate } from 'react-router'
import { links } from '@/utils/link'

interface MeasureOneWidgetProps {
  jobId: string
  config: string
  onTokenExpired: () => void
}

export function MeasureOneWidget({
  config,
  jobId,
  onTokenExpired,
}: MeasureOneWidgetProps) {
  const m1WidgetRef = useRef<HTMLElement>(null)
  const navigate = useNavigate()

  useLayoutEffect(() => {
    const element = m1WidgetRef.current

    if (!element) {
      return
    }

    const onExit = () =>
      void navigate(links.jobDetails(jobId), { replace: true })

    element.addEventListener('exitRequested', onExit)

    element.addEventListener('tokenExpired', onTokenExpired)

    return () => {
      element.removeEventListener('exitRequested', onExit)
      element.removeEventListener('tokenExpired', onTokenExpired)
    }
  }, [config, jobId, navigate, onTokenExpired])

  return <m1-link ref={m1WidgetRef} config={config} />
}
